var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfiabilidade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 36.5V5C8.5 4.07174 8.86875 3.1815 9.52513 2.52513C10.1815 1.86875 11.0717 1.5 12 1.5H26C26.9283 1.5 27.8185 1.86875 28.4749 2.52513C29.1313 3.1815 29.5 4.07174 29.5 5V36.5M8.5 36.5H29.5M8.5 36.5H5C4.07174 36.5 3.1815 36.1313 2.52513 35.4749C1.86875 34.8185 1.5 33.9283 1.5 33V22.5C1.5 21.5717 1.86875 20.6815 2.52513 20.0251C3.1815 19.3687 4.07174 19 5 19H8.5M29.5 36.5H33C33.9283 36.5 34.8185 36.1313 35.4749 35.4749C36.1313 34.8185 36.5 33.9283 36.5 33V17.25C36.5 16.3217 36.1313 15.4315 35.4749 14.7751C34.8185 14.1187 33.9283 13.75 33 13.75H29.5M15.5 8.5H22.5M15.5 15.5H22.5M15.5 22.5H22.5M15.5 29.5H22.5",
    stroke: "#25468E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfiabilidade);
export default __webpack_public_path__ + "static/media/confiabilidade.f3cf4f9e3e646141de10dcecbdbb4f3f.svg";
export { ForwardRef as ReactComponent };